module.exports = __webpack_public_path__ + "static/media/tmc-logo.db05465a.png";